import {
  Component,
  ElementRef,
  ViewChild,
  Renderer2,
  Input
} from "@angular/core";
import {SvcServices} from '../../services/svc.service';
import { ActivatedRoute, Params } from '@angular/router';
import { SiteCatalystService } from 'app/services/site-catalyst.service';



@Component({
  selector: "contact-us",
  templateUrl: "./contact-us.component.html"
})

export class ContactUsComponent{
  isNoCardNm: boolean = false;
  constructor(private _renderer: Renderer2,
    private _scService: SiteCatalystService,
    private _svcService: SvcServices,
    private _route: ActivatedRoute
  ) {
    this._renderer.listen('window', 'click', (e:Event)=>{
      if(e.target != this.selectWrapper.nativeElement && e.target != this.select.nativeElement){
        this.toggleState = 'close'
      }
    })
  }
  @ViewChild('selectWrapper') selectWrapper: ElementRef;
  @ViewChild('select') select: ElementRef;
  @ViewChild("contactUsList") contactUsList: ElementRef;

  public class_phone = "show-container";
  public switch_phone = "";
  public class_address = "show-container";
  public switch_address = "";
  @Input() contactus: any;
  isLiveEngageChat: boolean = false;
  globalData: any;
  configSet = new Set([]);
  products = new Set([]);
  cmsConfig: any;
  selectedCard: any;
  productName: any;
  productId: any = null;
  // selectedProduct:any;
  productArray = [];
  // productArray: any;
  validPartnerForMessage: boolean = false;
  isCPAYAccount: boolean = false;
  isTSAccount: boolean = false;
  brandId: any;
  siteId: any;
  isOpened: boolean = false;
  toggleState: string = 'close';
  ngOnInit() {
    this._route.queryParams.subscribe((qParam: Params) => {
      if (Object.keys(qParam).length > 0) {
          if(qParam.brandId)
            this.brandId = qParam.brandId.toLowerCase();
      }
    });
    this.cons();
    this.cmsConfig = this.productArray[0];
    this.selectedProduct();
    this.firstProductName();
    this.isCPAYAccnt();
    //this.isNoCardName();
    
  }

  // toggling the dropdown to be open and close
  toggleList() {
    this.toggleState = this.toggleState == 'close' ? this.toggleState = 'open': this.toggleState = 'close';
  }

  cons() {
    if (this.contactus.config$$rule_partner_catalog_contact_us) {
      if(this.brandId){
        this.contactus.config$$rule_partner_catalog_contact_us.catalogDetails.forEach(
          config => {
            this.productArray.push(this.contactus["config$$" + config]);
          }
        );
      } else{
        this.contactus.config$$rule_partner_catalog_contact_us.ruleResponse.forEach(
            config => {
              this.productArray.push(this.contactus["config$$" + config]);
            }
          );
      }
    }
  }

  selectedProduct(selectedTarget?) {
    this.selectedCard = selectedTarget;
    this._scService.setSCPageData("customFormInteraction",null,selectedTarget);
    for (let product of this.productArray) {
      if (product.card_program_name === selectedTarget) {
        this.productName = product.card_program_name;
        this.productId = product.product_brand_id;
        this.cmsConfig = product;
        if(this.contactus && this.contactus.copy$$installment_loan_account_name){
          if(this.productName === this.contactus.copy$$installment_loan_account_name.TEXT){
            this._svcService.languageSuppressMIL.emit(true);
          }
          else {
            this._svcService.languageSuppressMIL.emit(false);
          }
        } 
        if(this.productId === 'MIL'){
          this._svcService.productIdContactUs.emit('MIL');
        }
        if(this.productId === 'DLOC'){
          this._svcService.productIdContactUs.emit('DLOC');
        }
      }
    }
  }
  
  numOfProducts() {
    return this.productArray.length;
  }
  firstProductName() {
    if (this.productArray[0]) {
      this.productName = this.productArray[0].card_program_name;
    }
  }
  toggle_phone() {
    if (this.class_phone == "show-container") {
      this.class_phone = "";
      this.switch_phone = "switched";
    } else {
      this.class_phone = "show-container";
      this.switch_phone = "";
    }
  }
  toggle_address() {
    if (this.class_address == "show-container") {
      this.class_address = "";
      this.switch_address = "switchedAddress";
    } else {
      this.class_address = "show-container";
      this.switch_address = "";
    }
  }
  
  isCPAYAccnt(){
    if(this._svcService.getSiteId() && this._svcService.getSiteId()=== "PLCN_CPAY"){
      this.isCPAYAccount = true;
      return true;
    } else {
      return false;
    }
  }

  isNoCardName(){
    if(this._svcService.getSiteId() && (this._svcService.getSiteId()=== "CACN_HOMEDEPOT" || this._svcService.getSiteId()=== "PLCN_HOMEDEPOT" || this._svcService.getSiteId()=== "PLOC_SHELL" || this._svcService.getSiteId()=== "PLOC_SUNOCO" || this._svcService.getSiteId()=== "PLCN_TRACTORSUPPLY" || this._svcService.getSiteId()=== "PLCN_JEWELRY") ){
      this.isNoCardNm = true;
     
    } else {
      this.isNoCardNm = false;
    }
  }
  isCmsWorkDays(){
    if(this._svcService.getSiteId() && ( this._svcService.getSiteId()=== "PLCN_TORO" || this._svcService.getSiteId()=== "PLCN_HOMEDEPOT" || this._svcService.getSiteId()=== "CACN_HOMEDEPOT" || this._svcService.getSiteId()=== "PLCN_BESTBUY" || this._svcService.getSiteId()=== "PLCN_DRIVECARD" || this._svcService.getSiteId()=== "PLCN_GOODYEAR" || this._svcService.getSiteId()=== "PLCN_JEWELRY" || this._svcService.getSiteId()=== "PLOC_SUNOCO" || this._svcService.getSiteId()=== "PLOC_SHELL" || this._svcService.getSiteId()=== "PLCN_TRACTORSUPPLY" )){

      return true;
    } else {
      return false;
    }
  }
  isCmsConfigAccnt(){
    if(this._svcService.getSiteId() && (this._svcService.getSiteId()=== "PLCN_SYW" || this._svcService.getSiteId()=== "PLCN_HOMEDEPOT" || this._svcService.getSiteId()=== "CACN_HOMEDEPOT" || this._svcService.getSiteId()=== "PLCN_DRIVECARD" || this._svcService.getSiteId()=== "PLCN_GOODYEAR" || this._svcService.getSiteId()=== "PLCN_BRANDSOURCE"  || this._svcService.getSiteId()=== "PLCN_JEWELRY" || this._svcService.getSiteId()=== "PLOC_SUNOCO" || this._svcService.getSiteId()=== "PLOC_SHELL" || this._svcService.getSiteId()=== "PLCN_TRACTORSUPPLY" || this._svcService.getSiteId()=== "PLCN_CPAY")){

      return true;
    } else {
      return false;
    }
  }

  isCPAYTHDAccnt(){
    if(this._svcService.getSiteId() && (this._svcService.getSiteId()=== "PLCN_CPAY" || this._svcService.getSiteId()=== "PLCN_HOMEDEPOT")){
      this.isCPAYAccount = true;
      return true;
    } else {
      return false;
    }
  }

  isTHDAccnt(){
    if(this._svcService.getSiteId() && this._svcService.getSiteId()=== "PLCN_HOMEDEPOT"){
      return true;
    } else {
      return false;
    }
  }

 
  
  // Show Send Message section shown for only certain partners.
  public isSendMessageSectionEnabled() {
    if ((
      this.contactus &&
      this.contactus.config$$cfg_cw_app_client_settings &&
      this.contactus.config$$cfg_cw_app_client_settings
        .partner_enabled_for_sendMessageSection_signOn &&
      this.contactus.config$$cfg_cw_app_client_settings.partner_enabled_for_sendMessageSection_signOn.includes(this._svcService.getSiteId()))) {
      return true;
    } else {
      return false;
    }
  }
}
